import React from "react";

interface ILoadingComponentProps {
    large?: boolean;
    extraSmall?: boolean;
}

const LoadingComponent = (props: ILoadingComponentProps) => {

    return (
        <>
            {props.extraSmall ? (
                <div
                    className="loader-box"
                    style={{ display: "flex", justifyContent: "center", padding: "0" }}
                >
                    <div
                        className={'loader-box__loader--small'}
                        style={{ borderWidth: "6px", width: "30px", height: "30px" }}
                    ></div>
                </div>
            ) : (
                <div className="loader-box">
                    {props.large ? (
                        <div className={'loader-box__loader'}></div>
                    ) : (
                        <div className={'loader-box__loader--small'}></div>
                    )}
                </div>
            )}
        </>
    );
};
export default LoadingComponent;